import React from 'react';
import {
  Box,
  Flex,
  Button,
  Text,
  Image,
  useMediaQuery,
  Heading,
} from '@podiumhq/design-system';

import { useNotificationContext } from 'contexts/NotificationContextProvider';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';

import AnimatedRoundedContentBox from '../../layout/AnimatedRoundedContentBox';
import { contentBoxMobileProps } from '../../styles';

import accountError from './assets/accountError.png';

const AccountError = ({ handleSubmit }) => {
  const [isSmallerThan650px] = useMediaQuery('(max-width: 650px)');
  const { errorReason } = useNotificationContext() || {};
  const trackEvent = useTrackAmplitudeEvent(
    'trials.createAccountError.visited'
  );
  const contentBoxProps = isSmallerThan650px
    ? { ...contentBoxMobileProps, paddingTop: '28vh' }
    : {
        animationBoxProps: { marginTop: '-12px' },
        height: '325px',
        margin: '18px',
        padding: '43px',
      };

  const handleTryAgain = () => {
    trackEvent('trials.createAccountError.tryAgainClicked');
    handleSubmit();
  };

  const titleText =
    errorReason === 'active_vpn'
      ? 'Please disable your VPN.'
      : errorReason === 'ad_blocker'
      ? 'Please turn off your ad blocker.'
      : 'Something went wrong';
  const bodyText =
    errorReason === 'active_vpn'
      ? 'Your VPN caused an error while we were setting up your Podium account. Please disable it and try again.'
      : errorReason === 'ad_blocker'
      ? 'It looks like you might have an ad blocker turned on. Please turn it off and try again.'
      : 'Hmm, something went wrong while we were setting up your Podium account. Please try again.';

  return (
    <Flex justifyContent="center">
      <AnimatedRoundedContentBox {...contentBoxProps}>
        <Box height="80x" margin="0 auto 16px auto" width="80px">
          <Image src={accountError} alt="something went wrong" />
        </Box>

        <Heading
          fontSize="xl"
          fontWeight="semibold"
          mb="16px"
          textAlign="center"
        >
          {titleText}
        </Heading>
        <Text fontSize="md" fontWeight="normal">
          {bodyText}
        </Text>

        <Box margin="24px auto 0 auto" width="135px">
          <Button onClick={handleTryAgain} size="lg" variant="primary">
            Try again
          </Button>
        </Box>
      </AnimatedRoundedContentBox>
    </Flex>
  );
};

export default AccountError;
